import React from 'react';

import './split-wipe.css';

// Total time for one direction of the wipe (matches split-wipe.css).
export const SPLIT_WIPE_MS = 800;

// Passed as router state so the room knows to open the split on arrival.
export const SPLIT_WIPE_STATE = { entrance: 'split' } as const;

export const isSplitEntrance = (state: unknown): boolean => (
  typeof state === 'object' && state !== null &&
  (state as { entrance?: unknown }).entrance === SPLIT_WIPE_STATE.entrance
);

type SplitWipeProps = {
  // "closing" slides the halves in until they meet on the diagonal;
  // "opening" starts closed and slides them apart.
  direction: 'closing' | 'opening';
  onDone?: () => void;
};

/*
 * The pink/blue diagonal split from the page background, used as a page
 * transition: the ice closes over the landing screen, then breaks back open
 * to reveal the room. Sits over whatever positioned container it's rendered in.
 */
export const SplitWipe = ({ direction, onDone }: SplitWipeProps) => (
  <div className={`splitWipe ${direction}`} aria-hidden="true">
    <span className="wipeGlow" />
    <span className="wipePink" />
    <span
      className="wipeBlue"
      onAnimationEnd={onDone}
    />
  </div>
);
